module.exports = __webpack_public_path__ + "img/wechat-title.091591e2.png";